import { isWorkItemModernizationGatesEnabled } from '@jira/issue__eligibility/src/isWorkItemModernizationGatesEnabled.tsx';
import { shouldShowWorkItemView } from '@jira/issue__eligibility/src/shouldShowWorkItemView.tsx';
import { issueViewSwitchDataFetcher } from '@jira/router-resources__work-item-view/src/issueViewSwitchDataFetcher.tsx';
import type { BifrostRedirectHandlerPayload } from '@jira/platform__routing-route-types/src/JiraSpaRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';

export const workItemRedirectionHandler = async ({
	match,
	url,
	tenantContext,
	isEmbed,
}: BifrostRedirectHandlerPayload & { isEmbed?: boolean }): Promise<string | undefined> => {
	try {
		const issueKey = match.params.issueKey || undefined;
		if (!issueKey) {
			return undefined;
		}

		const embedPath = isEmbed ? '/embed' : '';
		if (!isWorkItemModernizationGatesEnabled()) {
			return `/browse/${issueKey}${embedPath}${url.search}`;
		}

		const projectKey = issueKey.split('-')[0];

		// MWIV-814: prefer the canonical issue key from Jira to handle project key moves/renames.
		const {
			projectType,
			userPreference,
			issueKey: canonicalIssueKey,
			isCreatedFromAgenticTemplate,
			isAgenticWorkItemViewEnabled,
		} = fg('wiv-fix-redirection-issue-key')
			? await issueViewSwitchDataFetcher(projectKey, tenantContext.cloudId, issueKey)
			: await issueViewSwitchDataFetcher(projectKey, tenantContext.cloudId);

		const fromIssueKey = fg('wiv-fix-redirection-issue-key')
			? (canonicalIssueKey ?? issueKey)
			: issueKey;

		const shouldShowWiv = shouldShowWorkItemView({
			cloudId: tenantContext.cloudId,
			issueKey,
			isIssueViewWivEnabled: userPreference,
			projectType,
			isCreatedFromAgenticTemplate,
			isAgenticWorkItemViewEnabled,
		});

		if (!shouldShowWiv) {
			return `/browse/${fromIssueKey}${embedPath}${url.search}`;
		}
	} catch (error) {
		log.safeErrorWithoutCustomerData(
			'work-item.router-routes.work-item.route.entry',
			error instanceof Error ? error.message : 'Unable to redirect to issue view',
		);
	}
};
